import { render, staticRenderFns } from "./LoginCallback.vue?vue&type=template&id=65c74ea0&scoped=true"
import script from "./LoginCallback.vue?vue&type=script&lang=ts"
export * from "./LoginCallback.vue?vue&type=script&lang=ts"
import style0 from "./LoginCallback.vue?vue&type=style&index=0&id=65c74ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c74ea0",
  null
  
)

export default component.exports